<template>
  <span style="margin-right: 10px">
    <span v-if="this.$store.state.sysInit.manualChatPiStatus == 'Away' || this.$store.state.sysInit.manualChatPiStatus == 'Offline'">
      <span v-show="this.$store.state.sysInit.manualChatButtonStatus !='close'">
        <el-button
          size="small"
          :type="this.$store.state.sysInit.manualChatButtonType"
          plain
          @click="turnManualChatStart()"
          :disabled="true"
        >
          <!-- チャット開始 -->
          {{ this.$store.state.sysInit.html_const.cons_205_start}}
        </el-button>
      </span>
      <span v-show="this.$store.state.sysInit.manualChatButtonStatus=='close'">
        <el-button size="small" type="danger" plain @click="turnManualChatEnd()">
          <!-- チャット終了 -->
          {{this.$store.state.sysInit.html_const.cons_206_stop}}
        </el-button>
      </span>
    </span>
    <span v-else>
      <span v-show="this.$store.state.sysInit.manualChatButtonStatus !='close'">
        <el-button
          size="small"
          :type="this.$store.state.sysInit.manualChatButtonType"
          plain
          @click="turnManualChatStart()"
          :disabled="$store.state.sysInit.manualButtonDisabled"
        >
          <!-- チャット開始 -->
          {{this.$store.state.sysInit.html_const.cons_205_start}}
        </el-button>
      </span>
      <span v-show="this.$store.state.sysInit.manualChatButtonStatus=='close'">
        <el-button size="small" type="danger" plain @click="turnManualChatEnd()">
          <!-- チャット終了 -->
          {{this.$store.state.sysInit.html_const.cons_206_stop}}
        </el-button>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    async turnManualChatStart() {
      let res = await this.$store.dispatch("sysInit/checkChatPresence");
      console.log("isBooked:", res.data)
      if (res.data.isBooked) {
        this.$store.state.stt.isScroll = true;
         this.$store.state.stt.isMouse = true;
         console.log( "isscroll",this.$store.state.stt.isScroll)
       if (this.$store.state.sysInit.manualChatCreateIssueUserId) {
         //  this.$store.dispatch("sysInit/getUC1IssueAllText");
         this.$store.dispatch("sysInit/createManualChatIssue");
         // this.$store.state.sysInit.manualChatButtonStatus='close'
       } else {
         console.log("未选中");
         Message.warning({
           message: "未选中",
         });
       }
       // this.$store.state.sysInit.manualChatButtonType = "danger";
       // this.$store.state.sysInit.manualButtonDisabled = true;
       this.$store.state.sysInit.manualButtonStatus = "manualEnd";
       this.$store.state.sysInit.chatPiDiaLogVisible = false;
      } else {
        this.$message.warning("The customer is chatting whith other operator");
      }

    },

    turnManualChatEnd() {
      this.$store.state.stt.isScroll = false;
      this.$store.state.stt.isMouse = false;
      if (this.$store.state.sysInit.manualChatQuestionerId) {
        this.$store.state.stt.dialogVisible = true;
      }
    },
  },
};
</script>

<style>
</style>